import api from '../api';

const HumanResourcesService = {
  async uploadEmployeeFile(file) {
    const body = new FormData();
    body.append('file', file);
    body.append('category', 'Recursos Humanos');
    body.append('formName', 'Colaboradores');
    body.append('fieldName', 'Documentos do colaborador');
    const response = await api.post('/upload', body, {
      skipTransientRetry: true,
    });
    return {
      name: response?.data?.name || file?.name || 'documento',
      dataUrl: response?.data?.downloadPath || response?.data?.url || '',
      relativePath: response?.data?.relativePath || null,
    };
  },

  async fetchEmployeeFile(file, { signal } = {}) {
    if (file?.previewBlob) return { blob: file.previewBlob, name: file?.name || 'documento' };
    const source = file?.dataUrl || '';
    if (!source) throw new Error('Arquivo não disponível.');
    if (/^(?:data|blob):/i.test(source)) {
      const response = await fetch(source, { signal });
      if (!response.ok) throw new Error('Arquivo não disponível.');
      return { blob: await response.blob(), name: file?.name || 'documento' };
    }
    const response = await api.get(file.contentPath || source, { responseType: 'blob', signal, skipGlobalErrorModal: true });
    return { blob: response.data, name: file?.name || 'documento' };
  },

  async getCompanyProfile() {
    const response = await api.get('/company');
    return response?.data ?? null;
  },

  async listEmployees(params = {}) {
    const response = await api.get('/human-resources/employees', { params });
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async getEmployeeById(id) {
    const response = await api.get(`/human-resources/employees/${id}`);
    return response?.data ?? null;
  },

  async getAvailableUsers() {
    const response = await api.get('/human-resources/employees/available-users');
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async listEmployeeHistory(params = {}) {
    const response = await api.get('/human-resources/employees/history', { params });
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async createEmployeeHistory(payload) {
    const response = await api.post('/human-resources/employees/history', payload);
    return response?.data ?? null;
  },

  async updateEmployeeHistory(id, payload) {
    const response = await api.put(`/human-resources/employees/history/${id}`, payload);
    return response?.data ?? null;
  },

  async deleteEmployeeHistory(id) {
    await api.delete(`/human-resources/employees/history/${id}`);
  },

  async createEmployee(payload) {
    const response = await api.post('/human-resources/employees', payload);
    return response?.data ?? null;
  },

  async updateEmployee(id, payload) {
    const response = await api.put(`/human-resources/employees/${id}`, payload);
    return response?.data ?? null;
  },

  async deleteEmployee(id) {
    await api.delete(`/human-resources/employees/${id}`);
  },


  async listTalentJobs() {
    const response = await api.get('/human-resources/talent-jobs');
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async createTalentJob(payload) {
    const response = await api.post('/human-resources/talent-jobs', payload);
    return response?.data ?? null;
  },

  async updateTalentJob(id, payload) {
    const response = await api.put(`/human-resources/talent-jobs/${id}`, payload);
    return response?.data ?? null;
  },

  async deleteTalentJob(id) {
    await api.delete(`/human-resources/talent-jobs/${id}`);
  },

  async listTalentBank() {
    const response = await api.get('/human-resources/talent-bank');
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async createTalentBankEntry(payload) {
    const response = await api.post('/human-resources/talent-bank', payload);
    return response?.data ?? null;
  },

  async updateTalentBankEntry(id, payload) {
    const response = await api.put(`/human-resources/talent-bank/${id}`, payload);
    return response?.data ?? null;
  },

  async deleteTalentBankEntry(id) {
    await api.delete(`/human-resources/talent-bank/${id}`);
  },

  async getOverview() {
    const response = await api.get('/human-resources/reports/overview');
    return response?.data ?? null;
  },

  async listVacationControl() {
    const response = await api.get('/human-resources/vacations');
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  },

  async getVacationControlById(id) {
    const response = await api.get(`/human-resources/vacations/${id}`);
    return response?.data ?? null;
  },

  async downloadEmployeesReport(params = {}) {
    const response = await api.get('/human-resources/reports/employees.csv', {
      params,
      responseType: 'blob',
    });
    const disposition = response?.headers?.['content-disposition'] || '';
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    let fileName = `relatorio-colaboradores-${new Date().toISOString().slice(0, 10)}.csv`;
    if (match && match[1]) {
      try {
        fileName = decodeURIComponent(match[1]);
      } catch (error) {
        fileName = match[1];
      }
    }
    return { blob: response?.data, fileName };
  },


  async downloadEmployeesExcel(params = {}) {
    const response = await api.get('/human-resources/reports/employees.xlsx', {
      params,
      responseType: 'blob',
    });
    const disposition = response?.headers?.['content-disposition'] || '';
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    let fileName = `relatorio-colaboradores-${new Date().toISOString().slice(0, 10)}.xlsx`;
    if (match && match[1]) {
      try {
        fileName = decodeURIComponent(match[1]);
      } catch (error) {
        fileName = match[1];
      }
    }
    return { blob: response?.data, fileName };
  },

  async downloadEmployeesPdf(params = {}) {
    const response = await api.get('/human-resources/reports/employees.pdf', {
      params,
      responseType: 'blob',
    });
    const disposition = response?.headers?.['content-disposition'] || '';
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    let fileName = `relatorio-colaboradores-${new Date().toISOString().slice(0, 10)}.pdf`;
    if (match && match[1]) {
      try {
        fileName = decodeURIComponent(match[1]);
      } catch (error) {
        fileName = match[1];
      }
    }
    return { blob: response?.data, fileName };
  },
};

export default HumanResourcesService;
